/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class ListTypes {
    public static readonly ACCOUNT: string = 'account';

    public static readonly COLLECTION_FILTERS: string = 'collection-filters';

    public static readonly COLLECTION_ITEMS: string = 'collection-items';

    public static readonly COLLECTION_ONEPASS_ITEMS: string = 'collection-onepass-items';

    public static readonly COLLECTION_SEASON_PICKER: string = 'collection-season-picker';

    public static readonly HELP: string = 'help';

    public static readonly MENU_LANGUAGE: string = 'menu-langauge';

    public static readonly MYSHOWS_FILTER: string = 'myshows-filters';

    public static readonly MYSHOWS_ITEMS: string = 'myshows-items';

    public static readonly ONEPASS_MANAGER: string = 'onepass-manager';

    public static readonly PC_HELP: string = 'pc-help';

    public static readonly SIDEBAR_MENU_ITEMS: string = 'sidebar-menu-items';

    public static readonly MAIN_SETTINGS: string = 'main-settings';

    public static readonly USER_PREFERENCES: string = 'user-preferences';
}
